/**
 * Claves compartidas entre todos los componentes raiz de la biblioteca.
 * Introducidas en KB-160855 para exhibir fallos de autenticacion que el
 * `FintechTokenProvider` inyectado propague.
 */
const CommonI18n_esEs = {
  authError: {
    title: 'No se pudo realizar la autenticación',
    providerNotConfigured: 'FintechTokenProvider no configurado: llame a setTokenProvider antes de iniciar el componente.',
    customerTokenUnavailable: '¡No se pudo obtener el token de autenticación!',
    adminTokenUnavailable: '¡No se pudo obtener el token de administrador!',
  },
};

export default CommonI18n_esEs;
